import {
  Box,
  Divider,
  List,
  SwipeableDrawer,
  Typography,
  useTheme,
} from "@mui/material";
import driversidebarCover from "../../../../media/images/driversidebarCover.svg";

import React, { useState } from "react";
import { useAppDispatch, useAppSelector } from "../../../../hooks/useRedux";
import {
  setOpenDriverSidebar,
  setOpenOwnerSidebar,
} from "../../../../redux/features/settingSlice";
import {
  setOpenSnackbar,
  setSnackbarDescription,
  setSnackbarErrorStatus,
} from "../../../../redux/features/snackbarSlice";
import {
  setDialogStatus,
  setDialogTitle,
  setOpenDialog,
} from "../../../../redux/features/dialogSlice";
import CustomListItem from "./components/ListItem";

import Money_Report from "../../../../media/images/icons/Money_Report.png";
import BigCar_3d from "../../../../media/images/icons/bigcar-3d.png";
import ProfileImage from "../../../../media/images/profileImage.svg";
import InfoAuth from "../../../../media/images/icons/auth-info.svg";
import { Link, useLocation } from "react-router-dom";
import ThemeToggle from "../../../components/ThemeToggle";
import UserOctagone from "../../../../media/images/icons/user-octagone";
import ArrowLeftCircle from "../../../../media/images/icons/arrow-left-circle";

import CloseImg from "../../../../media/images/icons/CloseImg.svg";
import useLogout from "../../../../hooks/useLogout";
import LogoutSVG from "../../../../media/images/icons/login-newsvg";
// import AuthLink from "./components/AuthLink";
import AuthorizationOwnerLabel from "../../../components/AuthorizationOwnerLabel";
import EmptyWallet from "../../../../media/images/icons/empty-wallet";
import SmsEditSVG from "../../../../media/images/icons/sms-edit";
import InfoCircle from "../../../../media/images/icons/info-circle";
import PenSVG from "../../../../media/images/icons/pen-square 1";
import BuildingSingleSVG from "../../../../media/images/icons/building-single";
import RefreshSVG from "../../../../media/images/icons/refresh";
import { triggerServiceWorkerUpdate } from "../../../../utils/serviceWorkerUpdate";

export default function OwnerSidebar() {
  const ownerSidebar = useAppSelector((state) => state.settings.ownerSidebar);
  const themeMode = useAppSelector((state) => state.settings.themeMode);
  const dispatch = useAppDispatch();

  const { pathname } = useLocation();

  const theme = useTheme();

  const { ownerInfo } = useAppSelector((state) => state.owner);

  const [handleLogout] = useLogout();
  const [isUpdating, setIsUpdating] = useState(false);

  const handleUpdateApp = async () => {
    if (isUpdating) return;
    setIsUpdating(true);
    try {
      const result = await triggerServiceWorkerUpdate();
      if (!result.reloaded && result.message) {
        if (result.success) {
          dispatch(setOpenOwnerSidebar(false));
          dispatch(setDialogStatus("success"));
          dispatch(setDialogTitle(result.message));
          dispatch(setOpenDialog(true));
          setTimeout(() => dispatch(setOpenDialog(false)), 3000);
        } else {
          dispatch(setSnackbarErrorStatus(400));
          dispatch(setSnackbarDescription(result.message));
          dispatch(setOpenSnackbar(true));
        }
      }
    } finally {
      setIsUpdating(false);
    }
  };

  const toggleDrawer =
    (open: boolean) => (event: React.KeyboardEvent | React.MouseEvent) => {
      if (
        event &&
        event.type === "keydown" &&
        ((event as React.KeyboardEvent).key === "Tab" ||
          (event as React.KeyboardEvent).key === "Shift")
      ) {
        return;
      }

      dispatch(setOpenOwnerSidebar(false));
    };

  return (
    <Box>
      <style>
        {`
      .MuiDrawer-modal {
  max-width: 450px;
  margin-right: auto;
  margin-left: auto;
  /* overflow-x: visible; */
  overflow-y: hidden;
}
  .sidebarDrawer {
  max-width: 450px;
  z-index:3000;
  margin-right: auto;
  margin-left: auto;
  /* overflow-x: visible; */
  overflow-y: hidden;
}
`}
      </style>
      <SwipeableDrawer
        className="sidebarDrawer"
        dir="rtl"
        sx={{
          "& .MuiPaper-root": {
            width: 270,
            position: "absolute",
            bgcolor: theme.palette.bgColor.blueGrey50,
            right: "0px",
            top: "0px",
            bottom: "0px",
            height: "auto",
            // borderRadius: "15px",
            display: "flex",
            flexDirection: "column",
            gap: 2,
            paddingBottom: "16px",
          },
        }}
        anchor="right"
        open={ownerSidebar}
        onClose={toggleDrawer(false)}
        onOpen={toggleDrawer(true)}
        disableSwipeToOpen={true}
      >
        <Box
          sx={{
            backgroundImage: `
            url(${driversidebarCover})`,
            backgroundRepeat: "no-repeat",
            backgroundSize: "cover",
            backgroundPosition: "center",
            backgroundColor: theme.palette.secondary[700],
            display: "flex",
            flexDirection: "column",
            justifyContent: "end",
            padding: "8px 8px",
          }}
        >
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            <img
              onClick={() => dispatch(setOpenOwnerSidebar(false))}
              src={CloseImg}
              alt=""
            />
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                backgroundColor: theme.palette.bgColor.grey100,
                borderRadius: "8px",
                padding: "6px",
                gap: "8px",
              }}
            >
              <Typography>حالت تاریک</Typography>
              <ThemeToggle />
            </Box>
          </Box>
          <Box
            sx={{
              marginTop: "8px",
              backgroundColor: "bgColor.white",
              // border: "1px solid gray",
              display: "flex",
              flexDirection: "column",
              gap: "8px",
              alignItems: "center",
              borderRadius: "10px",
              padding: "8px",
            }}
          >
            <Box
              sx={{
                width: "100%",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: "4px",
                }}
              >
                <img
                  style={{
                    borderRadius: "50%",
                  }}
                  width={40}
                  src={ProfileImage}
                  alt=""
                />
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "4px",
                  }}
                >
                  <Typography
                    sx={{
                      fontSize: "12px",
                      fontWeight: "700",
                    }}
                  >
                    {ownerInfo?.companyName
                      ? ownerInfo.companyName
                      : ownerInfo?.foreName + " " + ownerInfo?.surName}
                  </Typography>
                  <AuthorizationOwnerLabel />
                </Box>
              </Box>
              <Typography
                sx={{
                  fontSize: "12px",
                }}
              >
                {ownerInfo?.phoneNumber}
              </Typography>
            </Box>
            {/* بنر تکمیل مدارک و پروفایل
            {!isConfirm && <AuthLink />}
            */}
          </Box>
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              gap: "8px",
              mt: 1,
            }}
          >
            <Link
              to={"/owner/profile"}
              style={{
                padding: "8px 4px",
                backgroundColor: theme.palette.bgColor.white,
                borderRadius: "12px",
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                // border: "1px solid gray",
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: "3px",
                }}
              >
                <UserOctagone
                  color={
                    themeMode === "light"
                      ? theme.palette.textColor.main
                      : "#fff"
                  }
                />
                <Typography>مشخصات حساب کاربری</Typography>
              </Box>
              <ArrowLeftCircle
                color={
                  themeMode === "light" ? theme.palette.textColor.main : "#fff"
                }
              />
            </Link>
            <Link
              to={"/owner/wallet"}
              style={{
                padding: "8px 4px",
                backgroundColor: theme.palette.bgColor.white,
                borderRadius: "12px",
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: "3px",
                }}
              >
                <EmptyWallet
                  color={
                    themeMode === "light"
                      ? theme.palette.textColor.main
                      : "#fff"
                  }
                />
                <Typography>کیف پول </Typography>
              </Box>
              <ArrowLeftCircle
                color={
                  themeMode === "light" ? theme.palette.textColor.main : "#fff"
                }
              />
            </Link>
          </Box>
        </Box>

        <Box
          sx={{
            display: "flex",
            gap: "8px",
            px: "8px",
          }}
        >
          <Link
            to={"manage-orders"}
            style={{
              flex: "1",
              height: 38,
              overflow: "hidden",
              borderRadius: "8px",
              padding: "0px 0px",
              width: "fit-content",
              display: "flex",
              alignItems: "center",
              backgroundColor: theme.palette.primary.main,
              gap: "3px",
            }}
          >
            <img width={40} src={BigCar_3d} alt="" />
            <Typography
              sx={{
                color: "#fff",
                fontSize: "14px",
              }}
            >
              مدیریت سفارشات{" "}
            </Typography>
          </Link>
          <Link
            to={"add-order"}
            style={{
              flex: "1",
              // height: 32,
              overflow: "hidden",
              borderRadius: "8px",
              padding: "0px 0px",
              width: "fit-content",
              display: "flex",
              alignItems: "center",
              backgroundColor: theme.palette.primary.main,
            }}
          >
            <img height={40} width={40} src={Money_Report} alt="" />
            <Typography
              sx={{
                whiteSpace: "nowrap",
                color: "#fff",
                fontSize: "14px",
              }}
            >
              ثبت سفارش{" "}
            </Typography>
          </Link>
        </Box>

        <Box
          sx={{
            paddingX: "8px",
            display: "flex",
            flexDirection: "column",
            gap: "8px",
          }}
        >
          <Box
            sx={{
              backgroundColor: "bgColor.white",
              // border: "1px solid gray",
              borderRadius: "10px",
              width: "100%",
              maxWidth: 360,
            }}
          >
            <nav
              style={{
                padding: "0px 8px",
              }}
              aria-label="main mailbox folders"
            >
              <List
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "4px",
                }}
              >
                {/* <CustomListItem
                  path="/owner/notifs"
                  title="اعلان‌ها"
                  icon={
                    <GuidSVG size={20} color={theme.palette.textColor.main} />
                  }
                /> */}
                {/* <Divider variant="middle" /> */}
                <CustomListItem
                  path="/owner/ticket"
                  title="ثبت تیکت"
                  icon={
                    <SmsEditSVG
                      size={20}
                      color={
                        pathname === "/owner/ticket"
                          ? "#fff"
                          : theme.palette.textColor.main
                      }
                    />
                  }
                />
                <Divider variant="middle" />
                <CustomListItem
                  path="/owner/survey"
                  title="نظرسنجی"
                  icon={
                    <PenSVG
                      size={20}
                      color={
                        pathname === "/owner/survey"
                          ? "#fff"
                          : theme.palette.textColor.main
                      }
                    />
                  }
                />
                {/* <Divider variant="middle" />
                <CustomListItem
                  path="#"
                  title="آمار فعالیت"
                  icon={
                    <GuidSVG size={20} color={theme.palette.textColor.main} />
                  }
                /> */}
                {/* <Divider variant="middle" />
                <CustomListItem
                  path="#"
                  title="مناقصات‌بار"
                  icon={
                    <GuidSVG size={20} color={theme.palette.textColor.main} />
                  }
                /> */}
                <Divider variant="middle" />
                <CustomListItem
                  path="/owner/communicate-companies"
                  title="ارتباط با شرکت‌ها"
                  icon={
                    <BuildingSingleSVG
                      size={20}
                      color={
                        pathname === "/owner/communicate-companies"
                          ? "#fff"
                          : theme.palette.textColor.main
                      }
                    />
                  }
                />
                <Divider variant="middle" />
                {/* <Divider variant="middle" />
                <CustomListItem
                  path="#"
                  title="ارتباط با شرکت‌ها"
                  icon={TermsIcon}
                /> */}
                {/* <Divider variant="middle" />
                <CustomListItem
                  path="#"
                  title="آدرس های ذخیره"
                  icon={
                    <GuidSVG size={20} color={theme.palette.textColor.main} />
                  }
                /> */}

                <CustomListItem
                  path="/terms"
                  title="قوانین"
                  icon={
                    <InfoCircle
                      size={20}
                      color={
                        pathname === "/terms"
                          ? "#fff"
                          : theme.palette.textColor.main
                      }
                    />
                  }
                />
                <Divider variant="middle" />
                <CustomListItem
                  title={isUpdating ? "در حال بروزرسانی..." : "به روز رسانی"}
                  icon={
                    <RefreshSVG
                      size={20}
                      color={theme.palette.textColor.main}
                    />
                  }
                  actionOnly
                  handleClick={handleUpdateApp}
                />
                <Divider variant="middle" />
                <CustomListItem
                  type="exit"
                  handleClick={() => handleLogout()}
                  path="#"
                  title="خروج از حساب کاربری"
                  icon={<LogoutSVG color={theme.palette.error.main} />}
                />
              </List>
            </nav>
          </Box>
          {/* <Box
            sx={{
              backgroundColor: "background.default",
              // border: "1px solid gray",
              borderRadius: "10px",
              width: "100%",
              maxWidth: 360,
            }}
          >
            <nav
              style={{
                padding: "0px 8px",
              }}
              aria-label="main mailbox folders"
            >
              <List
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "4px",
                }}
              >
                <CustomListItem
                  path="/karenclub/courses"
                  title="آموزش ببین و امتیاز بگیر"
                  icon={
                    <GuidSVG size={20} color={theme.palette.textColor.main} />
                  }
                />
                <CustomListItem
                  path="/guides"
                  title="راهنمای جامع بازارگاه"
                  icon={
                    <GuidSVG size={20} color={theme.palette.textColor.main} />
                  }
                />
                <CustomListItem
                  path="/terms"
                  title="قوانین"
                  icon={
                    <GuidSVG size={20} color={theme.palette.textColor.main} />
                  }
                />
                <CustomListItem
                  type="exit"
                  handleClick={() => handleLogout()}
                  path="#"
                  title="خروج از حساب کاربری"
                  icon={<LogoutSVG color={theme.palette.error.main} />}
                />
                <CustomListItem path="#" title="آمار فعالیت" icon={NotifIcon} />
                <CustomListItem path="#" title="ثبت بار" icon={TermsIcon} />
              </List>
            </nav>
          </Box> */}
        </Box>

        {/* <Box
          sx={{
            backgroundColor: "background.default",
            // border: "1px solid gray",
            borderRadius: "10px",
            padding: "16px",
            width: "100%",
            maxWidth: 360,
            display: "flex",
            alignItems: "center",
            flexDirection: "column",
            gap: "8px",
          }}
        >
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: "8px",
            }}
          >
            <img width={20} src={CallIcon} alt="" />
            <Typography
              sx={{
                fontWeight: "600",
              }}
            >
              شماره تماس مرکز:
            </Typography>
          </Box>
          <Typography
            sx={{
              fontWeight: "600",
            }}
          >
            07633452480-3
          </Typography>
        </Box> */}
      </SwipeableDrawer>
    </Box>
  );
}
